import tocActions from '../actions/TocActions';

const defaultState = {
    filter: tocActions.filterTypes.ALL,
    itemsMap: {},
    itemsOrder: [],
    numberOfDocuments: 0,
    numberOfQuestions: 0,
    sectionStimulusMap: {},
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case tocActions.types.TOC_SET_QUESTIONS_INDEX:
        return action.questionsIndex;

    case tocActions.types.TOC_SET_FILTER:
        return Object.assign({}, state, {
            filter: action.filter,
        });

    default:
        return state;
    }
}
